/**
 * Telegram Login Widget Redirect-flow — клиентский bootstrap.
 *
 * После успешной авторизации backend редиректит юзера на
 *   /#med_token=<token>&med_name=<имя>
 * Мы читаем фрагмент один раз на загрузке, сохраняем в localStorage
 * и стираем hash из URL — чтобы токен не попал в screenshot/copy-paste.
 *
 * Аналог survivors/src/main.ts::applyTelegramRedirectIfPresent.
 */

export const TOKEN_KEY = 'med_token';
export const NAME_KEY = 'med_name';

export function consumeTelegramRedirect(): void {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash;
  if (!hash || !hash.includes('med_token=')) return;

  const params = new URLSearchParams(hash.slice(1));
  const token = params.get('med_token');
  const name = params.get('med_name');

  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (name) localStorage.setItem(NAME_KEY, name.slice(0, 64));

  // Чистим URL: оставляем pathname + search, без hash.
  history.replaceState(null, '', window.location.pathname + window.location.search);
}

export function getStoredToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredName(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(NAME_KEY);
}

export function clearStoredAuth(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(NAME_KEY);
}
